import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/pages/Dashboard';
import StockDetail from './components/pages/StockDetail';
import Favorites from './components/pages/Favorites';
import Settings from './components/pages/Settings';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <h1>株価変化点検出システム</h1>
          <nav>
            <a href="/">ダッシュボード</a>
            <a href="/favorites">お気に入り</a>
            <a href="/settings">設定</a>
          </nav>
        </header>

        <main className="App-main">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/stocks/:symbol" element={<StockDetail />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/settings" element={<Settings />} />
            {/* 不正なパスはダッシュボードにリダイレクト */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
